import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Empty, Icon, Input, Tooltip, Tree} from "antd";
import {Scrollbars} from "react-custom-scrollbars";

const {Search} = Input;
const {TreeNode} = Tree;
/**
 * creat by tianruojun
 * 选部门组件（树形）
 * @description 一个用来选部门的弹窗组件，可以设置回显和返回选择的部门
 * @class TreeModuleBySelectDept
 * @extends {Component}
 */

const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some(item => item.key === key)) {
                parentKey = node.key;
            } else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children);
            }
        }
    }
    return parentKey;
};
export default class TreeModule extends Component {
    static propTypes = {
        /**
         * @text 初始部门id
         * @category data
         */
        deptId: PropTypes.string,
        /**
         * @text 是否显示搜索框
         * @category data
         */
        showLeftSearch: PropTypes.bool,
        /**
         * @text 树结构进行勾选操作的回调
         * @category event
         */
        onCheck: PropTypes.func,
        /**
         * @text 回显勾选的部门
         * @category data
         */
        checkedKeys: PropTypes.array
    };
    static defaultProps = {
        deptId: '0',
        showLeftSearch: true,
        checkedKeys: [],
        checkedNodes: [],
        onCheck: (dept, call) => {
            console.log("选中的部门数据========", dept);
            call && call(true)
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            searchVal: "",
            autoExpandParent: true,
            expandedKeys: [props.deptId],
            checkedKeys: props.checkedKeys,
            checkedNodes: props.checkedKeys,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.checkedKeys != this.state.checkedKeys) {
            this.setState({checkedKeys:nextProps.checkedKeys})
        }
    }

    render() {
        const {showLeftSearch} = this.props;
        return (
            <div style={{flex: 1, border: '1px solid #d9d9d9'}}>
                {showLeftSearch ? this.renderSearch() : null}
                {this.renderTree()}
            </div>
        )
    }

    /**
     * 渲染搜索框
     */
    renderSearch = () => {
        const {onSearchTree} = this;
        return (
            <div style={{padding: '9px 17px', borderBottom: '1px solid #f0f0f0'}}>
                <Search
                    placeholder={'请输入关键字'}
                    allowClear={true}
                    onChange={(e) => {
                        let val = e.target.value;
                        onSearchTree(val)
                    }}
                    onSearch={(val) => {
                        onSearchTree(val)
                    }}/>
            </div>
        )
    };

    /**
     * 渲染树结构
     */
    renderTree = () => {
        const {height, treeData} = this.props;
        let {autoExpandParent,expandedKeys,checkedKeys} = this.state;
        let empty = this.getEmpty(treeData);
        let treeNodes = <></>;
        if (empty) {
            treeNodes = this.renderTreeNodes(treeData, 0);
            if (!treeNodes) {
                empty = false;
            }
        }
        return (
            <div style={{padding: '20px 0px 0px 10px'}} id={'treeBox'}>
                <Scrollbars autoHide style={{height: height - 51 - 30}}>
                    {empty ? <Tree
                            showIcon
                            // defaultExpandParent={true}
                            // defaultExpandAll={true}
                            // 展示复选框
                            checkable
                            // 展开的节点
                            expandedKeys={expandedKeys}
                            // 自动展开对应的父节点
                            autoExpandParent={autoExpandParent}
                            // defaultExpandedKeys={['0']}
                            // 展开节点回调
                            onExpand={this.onExpand}
                            // 选中节点回调
                            onCheck={this.onCheck}
                            checkedKeys={checkedKeys}
                            selectable={false}
                            checkStrictly={true}
                        >
                            {treeNodes}
                        </Tree>
                        : <div style={{position: "relative", top: '50%', marginTop: '-100px'}}><Empty/></div>}
                    <style>{
                        `
                    #treeBox .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected { background-color: #ffffff;}
                    #treeBox::-webkit-scrollbar { 
                            width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
                            height:0px;
                        }
                    #treeBox::-webkit-scrollbar-thumb {
                            border-radius: 10px;
                            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                            background: rgba(0,0,0,0.2);
                        }
                    #treeBox::-webkit-scrollbar-track {
                            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.02);
                            border-radius: 0;
                            background: rgba(0,0,0,0.01);
                       }
                    
                    `
                    }</style>
                </Scrollbars>
            </div>
        )
    };

    renderTreeNodes(data, floor, parentShow) {
        const {nodeIcon, fileIcon} = this.props;
        let result = [];
        data && data.length && data.forEach(item => {
            let needSon = item.children;
            let showNode = true;
            // try {
            //     showNode = this.showNode(item)
            // } catch (e) {
            //     showNode = true
            // }

            if (item.children) {
                let childTreeNodes = this.renderTreeNodes(item.children, floor + 1);

                // if (childTreeNodes) {
                result.push(
                    <TreeNode style={{display: showNode ? 'list-item' : 'none'}}
                              title={this.renderTitle(nodeIcon, item, floor)} key={item.key} dataRef={item}>
                        {childTreeNodes}
                    </TreeNode>
                );
                return;
                // }
            }
            if (showNode) {
                result.push(<TreeNode style={{display: item.isStepson ? 'none' : 'list-item'}}
                                      key={item.key} title={this.renderTitle(fileIcon, item, floor)} dataRef={item}/>);
            }
        });
        if (result.length > 0) {
            return result;
        }
        return null;
    };

    renderTitle = (iconType, item, floor) => {
        const {nodeWidth = 190, nodeTextWidth = 160, nodeRightIcon} = this.props;
        const {searchVal} = this.state;
        // const index = searchVal.length > 0 ? item.title.indexOf(searchVal) : -1;
        let width1 = nodeWidth - floor * 19;
        let width2 = nodeTextWidth - floor * 19;

        const index = item.title.indexOf(searchVal);
        const beforeStr = item.title.substr(0, index);
        const afterStr = item.title.substr(index + searchVal.length);
        const title =
            index > -1 ? (
                <span style={{
                    width: width2,
                    overflow: 'hidden',
                    marginLeft: '5px',
                    textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
              {beforeStr}
                    <span style={{color: '#f50'}}>{searchVal}</span>
                    {afterStr}
            </span>
            ) : (
                <span style={{
                    width: width2,
                    overflow: 'hidden',
                    marginLeft: '5px',
                    textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>{item.title}</span>
            );
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: width1,}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    {iconType ? <Icon type={iconType}/> : null}
                    <Tooltip placement="top" title={item.title}>
                        {title}
                        {/*<span style={{*/}
                        {/*    width: width2,*/}
                        {/*    overflow: 'hidden',*/}
                        {/*    marginLeft: '5px',*/}
                        {/*    textOverflow: 'ellipsis', whiteSpace: 'nowrap',*/}
                        {/*    color: index > -1 ? '#f50' : 'unset'*/}
                        {/*}}*/}
                        {/*>{item.title}</span>*/}
                    </Tooltip>
                </div>
                {/*<div onClick={()=>{this.setCollect(item)}}>{item.collect ? <Icon type="star" theme="filled" style={{color:"#f0a738"}} /> : <Icon type={nodeRightIcon} />}</div>*/}
            </div>
        )
    };

    /**
     * 搜索框点击搜索回调
     * @param {string} val 搜索框的内容
     */
    onSearchTree = (value) => {
        let expandedKeys = [this.props.deptId];
        let hasSearchNodeKey = [];
        if(value) {
            try {
                // 获取所有符合条件的节点key
                this.getHasSearchNodeKey(value, this.props.treeData, hasSearchNodeKey);
                // 获取符合条件节点的父节点key
                this.getExpandedKeysBySearch(value, this.props.treeData, expandedKeys, hasSearchNodeKey);
            } catch (e) {
                console.log(e.toString())
            }
        }
        this.setState({searchVal: value, autoExpandParent: true,expandedKeys})
    };

    /**
     * 获取所有符合搜索条件的节点的key
     * @param {string} search 搜索的字段
     * @param {array} treeData 所有部门数据
     * @param {array} hasSearchNodeKey 用来存储结果的容器
     */
    getHasSearchNodeKey = (search, treeData, hasSearchNodeKey) => {
        if(treeData && treeData.length) {
            treeData.forEach(item=>{
                if(item.title.indexOf(search) > -1) {
                    hasSearchNodeKey.push(item.key)
                }
                if(item.children && item.children.length) {
                    this.getHasSearchNodeKey(search, item.children, hasSearchNodeKey);
                }
            });
        }
    };

    /**
     * 便利符合条件的节点key，并寻找其父节点key
     * @param {string} search 搜索的字段
     * @param {array} treeData 所有部门数据
     * @param {array} expandedKeys 用来存储其父节点Key的容器
     * @param {array} hasSearchNodeKey 用来存储符合搜索条件节点key的容器
     */
    getExpandedKeysBySearch = (search, treeData, expandedKeys, hasSearchNodeKey) => {
        if(hasSearchNodeKey && hasSearchNodeKey.length) {
            hasSearchNodeKey.forEach(item=>{
                this.getParentKey(item, treeData, expandedKeys);
            })
        }
    };

    /**
     * 根据节点key寻找其父节点key
     * @param {string} search 搜索的字段
     * @param {array} treeData 所有部门数据
     * @param {array} expandedKeys 用来存储其父节点Key的容器
     */
    getParentKey = (key, tree, expandedKeys) => {
        for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node.children) {
                if (node.children.some(item => item.key === key)) {
                    expandedKeys.push(node.key)
                }
                this.getParentKey(key, node.children, expandedKeys);
            }
        }
    };

    /**
     * 树结构点击选中回调
     * @param {string, array} checkedKeys选中节点的key, info选中的结构参数
     */
    onCheck = (checkedKeys, info) => {
        let nodes = info.checkedNodes;
        // let node = nodes[0].props.dataRef; // 当前选中的节点完整数据
        this.state.checkedKeys = checkedKeys;
        this.state.checkedNodes = nodes.map(item => item.props.dataRef);
        this.setState({}, ()=>{
            this.props.onCheck(this.state.checkedKeys, this.state.checkedNodes);
            console.log("checkedKeys==========",this.state.checkedKeys);
            console.log("checkedNodes==========",this.state.checkedNodes)
        });
    };

    getEmpty = (treeData) => {
        const {searchVal} = this.state;
        if (!(treeData && treeData.length)) return false;
        if (searchVal) {
            return this.getSearchEmpty(treeData, searchVal)
        } else {
            return true
        }
    };

    getSearchEmpty = (treeData, searchVal) => {
        return treeData.find(item => {
            if (item.title.indexOf(searchVal) > -1) {
                return true;
            } else if (item.children && item.children.length) {
                return this.getSearchEmpty(item.children, searchVal)
            } else {
                return false
            }
        });
    };

    showNode = (item) => {
        const {searchVal} = this.state;
        if (!searchVal) return true; //如果没有搜索字段则显示全部部门数据 && 如果当前数据是人则显示
        // 以下是有搜索的情况
        return this.haveSearchPerson([item], searchVal); // 当前部门是否含有符合搜索字段的人
    };

    haveSearchPerson = (tree, searchVal) => {
        return tree.some(item => {
            if (item.children && item.children.length) {
                return this.haveSearchPerson(item.children, searchVal)
            } else {
                return item.title.indexOf(searchVal) > -1
            }

            // if(item.type === "person") {
            //     return item.name.indexOf(searchVal)>-1
            // } else if (item.children && item.children.length) {
            //     return this.haveSearchPerson(item.children, searchVal)
            // } else {
            //     return false
            // }
        })
    };

    onExpand = (expandedKeys ) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    };

}